import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

interface FunnelStage {
  label: string;
  count: number;
  color: string;
}

interface ConversionFunnelProps {
  stages: FunnelStage[];
}

export function ConversionFunnel({ stages }: ConversionFunnelProps) {
  const maxCount = Math.max(...stages.map((s) => s.count), 1);

  return (
    <Card>
      <CardContent className="p-4">
        <h4 className="text-xs font-semibold text-muted-foreground mb-4 flex items-center gap-1.5">
          <TrendingUp className="w-3.5 h-3.5" />
          CONVERSION FUNNEL
        </h4>
        <div className="space-y-2">
          {stages.map((stage, i) => {
            const widthPct = (stage.count / maxCount) * 100;
            const convRate =
              i > 0 && stages[i - 1].count > 0
                ? ((stage.count / stages[i - 1].count) * 100).toFixed(0)
                : null;
            return (
              <div key={stage.label}>
                <div className="flex items-center justify-between mb-0.5">
                  <span className="text-xs font-medium">{stage.label}</span>
                  <span className="text-xs tabular-nums">
                    {stage.count}
                    {convRate && (
                      <span className="text-muted-foreground ml-1">({convRate}%)</span>
                    )}
                  </span>
                </div>
                <div className="h-6 bg-gray-50 rounded overflow-hidden">
                  <div
                    className="h-full rounded flex items-center justify-end pr-2 transition-all duration-500"
                    style={{
                      width: `${Math.max(widthPct, 4)}%`,
                      backgroundColor: stage.color,
                    }}
                  >
                    {widthPct > 20 && (
                      <span className="text-xs font-medium text-white">{stage.count}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
